module.exports = "\r\n/*customs*/\r\n\r\n.container {\r\n    margin-top: 3em;\r\n    width: 80%;\r\n}\r\n\r\n.collection-item {\r\n    text-align: left;\r\n}\r\n\r\n.item-email {\r\n    padding-top: 10px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/friendList/friendlist.component.css
// module id = ./src/app/components/friendList/friendlist.component.css
// module chunks = main